import React, { Component } from 'react';
// import SettingsSvg from 'assets/svg/settings.svg';

export default class Settings extends Component {
  render() {
    return (
      <div className="app-settings-body">
        <h1>{trans`Admin Settings`}</h1>
        <blockquote className="blockquote-primary">
          No Settings Yet
        </blockquote>
      </div>
    );
  }
}
